import useContacts from "../data/useContacts";

export function useContactLookup() {
  const { contacts } = useContacts();

  const contactLookup = (contactId: string) =>
    contacts.data?.data?.find((c) => c.id === contactId);

  return {
    contactLookup,
    isLoading: contacts.isLoading,
  };
}
